import React from 'react';
import PropTypes from 'prop-types';
import './FormAnalyse.scss';

const FormAnalyse = () => {
  return(
    <div className="FormAnalyse" data-testid="FormAnalyse">
      FormAnalyse Component
    </div>
  )
};

export default FormAnalyse;
